import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { clsx } from "clsx";
import * as React from "react";
import { twMerge } from "tailwind-merge";

function cn(...inputs: any[]) {
    return twMerge(clsx(inputs));
}

const ToggleGroup = React.forwardRef<
    React.ElementRef<typeof ToggleGroupPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
    <ToggleGroupPrimitive.Root
        ref={ref}
        className={cn("inline-flex gap-2", className)}
        {...props}
    />
));
ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;

const ToggleGroupItem = React.forwardRef<
    React.ElementRef<typeof ToggleGroupPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Item>
>(({ className, children, ...props }, ref) => (
    <ToggleGroupPrimitive.Item
        ref={ref}
        className={cn(
            // layout
            "inline-flex items-center justify-center",

            // shape & spacing
            "rounded-full px-5 py-2",

            // typography
            "text-md font-medium",

            // default (unselected)
            "border border-[#C9C9C9] bg-[#EEEEEE] text-[#424242]",

            // hover
            "hover:bg-gray-100 hover:text-gray-700",

            // selected
            "data-[state=on]:bg-brand-atlantic",
            "data-[state=on]:border-brand-atlantic",
            "data-[state=on]:text-white",
            "data-[state=on]:shadow-md",

            // focus & disabled
            "focus-visible:ring-brand-atlantic transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
            "disabled:pointer-events-none disabled:opacity-50",

            className,
        )}
        {...props}
    >
        {children}
    </ToggleGroupPrimitive.Item>
));
ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;

export { ToggleGroup, ToggleGroupItem };
